<template>
    <div class="input-group input-group-sm">
        <select class="form-control" :value="value" @change="$emit('change', $event.target.value)">
            <option value="zero2one">O| - Zero to One</option>
            <option value="one2one">|| - One to One</option>
            <option value="zero2many">O&lt; - Zero to Many</option>
            <option value="one2many">|&lt; - One to Many</option>
        </select>
    </div>
</template>

<script>
    export default {
        name: "ErdRelationChooser",
        props: {
            title: {type: String, default: ''},
            value: {type: String},
        }
    }
</script>

